import { Component, OnInit, Compiler } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Chart } from 'chart.js';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';

@Component({
    selector: 'app-competency-report',
    templateUrl: './competency-report.component.html',
    styleUrls: ['./competency-report.component.css']
})
export class CompetencyReportComponent implements OnInit {
    selectedLevel: any = '';
    users: any = [];
    baseUrl: any;
    loginUserName: any;
    loading: any = false;
    userList: any = [];
    columnsList: any = [];
    userData: any = [];
    ibuList: any = [];
    towerList: any = [];
    tempTowerList: any = [];
    selectedIbuId: any = '';
    selectedTowerId: any = '';
    towerIdsBySelectedIbu: any = [];
    userReportData: any = [];
    behCompByTowers: any = [];
    tempTowerIdsBySelectedIbu: any = [];
    ibuName: any = '';
    funCompByTowers: any = [];
    userAllNotesList: any = [];
    positionList: any = [];
    behDataByTower: any = [];
    funDataByTower: any = [];
    behDataByTowerForStatus: any = [];
    funDataByTowerForStatus: any = [];
    userIbuIds: any = [];
    ibuListForTraining: any = []
    userRole = 0;
    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private excelService: ExcelService,
        private commonService: CommonService,
        private common: Common,
        private appConfig: AppConfig, config: NgbDatepickerConfig, private _compiler: Compiler
    ) {
        this.users = JSON.parse(localStorage.getItem('user'));
        // this.baseUrl = this.appConfig.getBaseUrl();
        if (!this.users || !this.users.userData) {
            this.commonService.logout();
            return;
        }
        if (this.users && this.users.userData) {
            this.users = this.users.userData;
            this.loginUserName = this.users.userFullName;
            this.userIbuIds = (this.users.ibuId) ? this.users.ibuId.split(',') : [];
            this.userRole = this.users.userRoll;
        }
    }

    ngOnInit(): void {
        this.getIbuList();
        this.getTowerList();
        this.getBehDataByTowerIdForReport();
        this.getFunDataByTowerIdForReport();
        this.getAllUserNotes();
        this.getFunDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReportForStatus();
        this.fetchPositions()
    }
    /**
    * Get list of IBU
    */
    getIbuList() {
        this.ibuList = [];
        this.commonService.getAllIBUInfo().subscribe(data => {
            if (data.length) {
                for (let i = 0; i < data.length; i++) {
                    const index = this.userIbuIds.findIndex(x => Number(x) == data[i].ibuId);
                    if (index != -1) {
                        this.ibuListForTraining.push(data[i]);
                    }
                }
                this.ibuList = data;
            }
        },
            error => {
                console.log('Ibu list not found', error);
            });
    }
    /**
     * Change IBU
     */
    changeIbu() {
        var tempTowerList = []
        this.towerIdsBySelectedIbu = [];
        this.towerList = this.tempTowerList;
        for (let i = 0; i < this.towerList.length; i++) {
            if (this.selectedIbuId == this.towerList[i].ibuId) {
                tempTowerList.push(this.towerList[i]);
                this.towerIdsBySelectedIbu.push(this.towerList[i].towerId);
            }
            if (i == this.towerList.length - 1) {
                this.towerList = tempTowerList;
                // Used in only change tower fun. if selected tower unselected.
                this.tempTowerIdsBySelectedIbu = this.towerIdsBySelectedIbu;
            }
        }
        this.getFunDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReport();
        this.getFunDataByTowerIdForReport();
    }
    /**
     * Get Tower List
     */
    getTowerList() {
        this.commonService.getTowerList().subscribe(data => {
            this.towerList = data;
            this.tempTowerList = data;
        },
            error => {
                console.log('Error', error);
            })
    }
    /**
     * Get the skill report on tower change.
     */
    changeTower() {
        // Push tower id 
        this.towerIdsBySelectedIbu = [];
        if (this.selectedTowerId) {
            this.towerIdsBySelectedIbu.push(this.selectedTowerId);
        } else {
            this.towerIdsBySelectedIbu = this.tempTowerIdsBySelectedIbu;
        }
        this.getFunDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReport();
        this.getFunDataByTowerIdForReport();
    }
    /**
     * Get user report data.
     */
    getUserReportData() {
        this.loading = true;
        let postData = { towerId: this.towerIdsBySelectedIbu };
        this.commonService.getUsersForReportByTowerIdsArr(postData).pipe(first()).subscribe(
            data => {
                let userIds = [];
                if (data && data.length > 0) {
                    this.userReportData = data;
                    this.exportReportData();
                    // this.loading = false;
                } else {
                    this.loading = false;
                    localStorage.setItem('errorMsg', 'Users Not Found');
                    this.commonService.showerror();
                }
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    /**
     * Excel Report
     */
    async exportReportData() {


        let excelExportData = [];
        // let headers = ["S.No.", "Employee Code", "Employee Name", "Email id", "IBU", "Function", "Tower", "Current Role", "Target Role", "Final Rating Status", "Self Rating Status (Behavioral)", "Self Rating Status (Functional)", "Manager Rating Status (Behavioral)", "Manager Rating Status (Functional)", "Rating Score Behavioral", "Rating Score Functional", "Aggregate Score", "Role Change Status"];
        let headers = ["S.No.", "Employee Code", "Employee Name", "Approve Date", "Email id", "IBU", "Function", "Tower", "Employee Status", "Batch Number", "Journey Completion Date", "TR Status", "Current Role", "Target Role",
            "Supervisor (1st Level)", "Supervisor (1st Level) Email", "Supervisor (2nd Level)", "Supervisor (2nd Level) Email", "Beh. Comp Submitted Date", "Fun. Comp Submitted Date", "Self Rating Status (Behavioral)",
            "Self Rating Status (Functional)", "Manager Rating Status (Behavioral)", "Manager Rating Status (Functional)", "Final Rating Status", "Rating Score Behavioral",
            "Rating Score Functional", "Average Score", "Role Change Status", "Notes"];
        // for (let i of this.fetchData)


        for (let i = 0; i < this.userReportData.length; i++) {
            let strData = '' + this.userReportData[i].email;
            if (strData.match(/_old$/)) continue;
            let data = {};
            data[headers[0]] = i + 1;
            data[headers[1]] = this.userReportData[i].empCode;
            data[headers[2]] = this.userReportData[i].userName;
            let approvDate = new Date(this.userReportData[i].approvedAt);
            data[headers[3]] = (this.userReportData[i].approvedAt) ? approvDate.getDate() + "-" + Number(approvDate.getMonth() + 1) + "-" + approvDate.getFullYear() : '';
            data[headers[4]] = this.userReportData[i].email;
            data[headers[5]] = this.getIbuNameById();
            data[headers[6]] = this.userReportData[i].functionName;
            data[headers[7]] = this.userReportData[i].towerName;
            if (this.userReportData[i].empStatus == 0) {
                data[headers[8]] = "Deactive";
            } else if (this.userReportData[i].empStatus == 2) {
                data[headers[8]] = "Resigned";
            } else {
                data[headers[8]] = "Active";
            }
            data[headers[9]] = this.userReportData[i].batchNo;
            data[headers[10]] = this.userReportData[i].journeyCompletionDate;
            data[headers[11]] = this.commonService.getUserStatus(this.userReportData[i].isApproved)
            data[headers[12]] = this.userReportData[i].positionName;
            //   data[headers[5]] = this.allPositions[this.fetchData[i].userId];
            data[headers[13]] = this.getPositionName(this.userReportData[i].nextPosition);
            data[headers[14]] = this.userReportData[i].resourceManager;
            data[headers[15]] = this.userReportData[i].resourceManagerEmail;
            data[headers[16]] = this.userReportData[i].SLS;
            data[headers[17]] = this.userReportData[i].SLSE;
            data[headers[18]] = this.getManagerBehCompLastDate(this.userReportData[i].userId);
            data[headers[19]] = this.getManagerFunCompLastDate(this.userReportData[i].userId);


            // var status = "Pending with Self";
            var compositeValues: any = this.getCompositeValueForExcel(this.userReportData[i].userId);
          

            data[headers[20]] = (this.checkSelfBehCompExist(this.userReportData[i].userId) > 0) ? 'Submitted' : 'Pending';
            data[headers[21]] = (this.checkSelfFunCompExist(this.userReportData[i].userId) > 0) ? 'Submitted' : 'Pending';
            data[headers[22]] = (this.checkManagerBehCompExist(this.userReportData[i].userId) > 0) ? 'Submitted' : 'Pending';
            data[headers[23]] = (this.checkManagerFunCompExist(this.userReportData[i].userId) > 0) ? 'Submitted' : 'Pending';

          
            if ((data[headers[20]] == 'Submitted' && data[headers[21]] == 'Submitted') && ((data[headers[22]] == 'Submitted' && data[headers[23]] == 'Submitted'))) {
                data[headers[24]] = 'Completed'
            }
            if (data[headers[22]] == 'Pending' || data[headers[23]] == 'Pending') {
                data[headers[24]] = 'Pending With Manager'
            }
            if (data[headers[20]] == 'Pending' || data[headers[21]] == 'Pending') {
                data[headers[24]] = 'Pending With Self'
            }


            data[headers[25]] = isNaN(compositeValues.beh) ? "" : compositeValues.beh;
            data[headers[26]] = isNaN(compositeValues.fun) ? "" : compositeValues.fun;
            data[headers[27]] = isNaN(compositeValues.full) ? "" : compositeValues.full;
            if (data[headers[27]] >= 80) { data[headers[28]] = "Ready Now"; }
            if (data[headers[27]] >= 60 && data[headers[27]] < 80) { data[headers[28]] = "Ready Soon"; }
            if (data[headers[27]] >= 30 && data[headers[27]] < 60) { data[headers[28]] = "Ready Future"; }
            if (data[headers[27]] < 30) { data[headers[28]] = " "; }
            data[headers[29]] = this.returnUserNotes(this.userReportData[i].userId)
            excelExportData.push(data);
            if (i == (this.userReportData.length - 1)) {
                this.loading = false;
                this.excelService.generateExcel(headers, excelExportData, 'Dashboard_Data');
            }
        }
       
    }
    /**
     * Get the competency and competency rating by towerIds
     */
    // Get Beh comp data


    /**
* Get user Notes
*/
    getAllUserNotes() {
        this.commonService.getAllUserNotes().subscribe(data => {
            this.loading = false;
            if (data) {
                this.userAllNotesList = data;

            }
        }, error => {
            console.log('Error', error);
            this.loading = false;
        });
    }
    /**
     * Return Users notes
     */
    returnUserNotes(userId) {
        for (let i = 0; i < this.userAllNotesList.length; i++) {
            if (userId == this.userAllNotesList[i].userId) {
                return this.userAllNotesList[i].userNotes;
            }
        }

    }

    private getPositionName(positionId) {
        for (let i = 0; i < this.positionList.length; i++) {
            if (this.positionList[i].positionId == positionId)
                return this.positionList[i].positionName;
        }
    }

    // Check users have self beh. competency submitted or not.
    getManagerBehCompLastDate($userId) {
        let lastDate = '';
        for (let i = 0; i < this.behDataByTowerForStatus.length; i++) {
            if (this.behDataByTowerForStatus[i].userId == $userId && this.behDataByTowerForStatus[i].ratedByRole == 4 && (lastDate == '' || new Date(lastDate) < new Date(this.behDataByTowerForStatus[i].createDate))) {

                lastDate = this.behDataByTowerForStatus[i].createDate;
            }
        }
        if (lastDate) {
            let date = new Date(lastDate);
            return date.getDate() + "-" + Number(date.getMonth() + 1) + "-" + date.getFullYear();
        } else {
            return lastDate;
        }
    }
    // Check users have self beh. competency submitted or not.
    getManagerFunCompLastDate($userId) {
        let lastDate = '';
        for (let i = 0; i < this.funDataByTowerForStatus.length; i++) {
            if (this.funDataByTowerForStatus[i].userId == $userId && this.funDataByTowerForStatus[i].ratedByRole == 4 && (lastDate == '' || new Date(lastDate) < new Date(this.funDataByTowerForStatus[i].createDate))) {

                lastDate = this.funDataByTowerForStatus[i].createDate;
            }
        }
        if (lastDate) {
            let date = new Date(lastDate);
            return date.getDate() + "-" + Number(date.getMonth() + 1) + "-" + date.getFullYear();
        } else {
            return lastDate;
        }
    }

    private getCompositeValueForExcel(userId) {
        var compositeBehSum = 0, compositeFunSum = 0;
        var managerPresentBeh = false, managerPresentFun = false, selfPresentBeh = false, selfPresentFun = false;
        var countBeh = 0, countFun = 0;

        for (var i = 0; i < this.behCompByTowers.length; i++) {
            if (this.behCompByTowers[i].ratedByRole == 4 && this.behCompByTowers[i].userId == userId) {
                managerPresentBeh = true;
                selfPresentBeh = true;
            }

            if (this.behCompByTowers[i].ratedByRole !== 4 || this.behCompByTowers[i].userId != userId) continue;

            var thisSkillsPercentage = (this.behCompByTowers[i].skillScore * 100) / this.behCompByTowers[i].targetScore;
            compositeBehSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
           
            countBeh++;
        }

        for (var j = 0; j < this.funCompByTowers.length; j++) {
            if (this.funCompByTowers[j].ratedByRole == 4 && this.funCompByTowers[j].userId == userId) {
                managerPresentFun = true;
                selfPresentFun = true;
            }

            if (this.funCompByTowers[j].ratedByRole !== 4 || this.funCompByTowers[j].userId != userId) continue;

            var thisSkillsPercentage = (this.funCompByTowers[j].skillScore * 100) / this.funCompByTowers[j].targetScore;

            compositeFunSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
            countFun++;
        }

        return {
            full: Math.floor(((compositeBehSum / countBeh) * 0.3 + (compositeFunSum / countFun) * 0.7)),
            beh: Math.floor(compositeBehSum / countBeh),
            fun: Math.floor(compositeFunSum / countFun),
            managerPresentFun,
            managerPresentBeh,
            selfPresentFun,
            selfPresentBeh
        };

    }

    // Check users have self beh. competency submitted or not.
    checkSelfBehCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.behDataByTowerForStatus.length; i++) {
            if (this.behDataByTowerForStatus[i].userId == $userId && this.behDataByTowerForStatus[i].ratedByRole == 5) {
                count++;
            }
        }
        return count;
    }
    // Check users have self beh. competency submitted or not.
    checkManagerBehCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.behDataByTowerForStatus.length; i++) {
            if (this.behDataByTowerForStatus[i].userId == $userId && this.behDataByTowerForStatus[i].ratedByRole == 4) {
                count++;
            }
        }
        return count;
    }

    // Check users have self beh. competency submitted or not.
    checkSelfFunCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.funDataByTowerForStatus.length; i++) {
            if (this.funDataByTowerForStatus[i].userId == $userId && this.funDataByTowerForStatus[i].ratedByRole == 5) {
                count++;
            }
        }
        return count;
    }
    // Check users have self beh. competency submitted or not.
    checkManagerFunCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.funDataByTowerForStatus.length; i++) {
            if (this.funDataByTowerForStatus[i].userId == $userId && this.funDataByTowerForStatus[i].ratedByRole == 4) {
                count++;
            }
        }
        return count;
    }


    // Get Beh comp data
    private getBehDataByTowerIdForReportForStatus() {
        this.loading = true;
        // let postData = { towerId: this.selectedTowerId };
        let postData = { towerId: this.towerIdsBySelectedIbu };
        this.commonService.getBehDataByTowerIdReportForStatus(postData).pipe(first()).subscribe(
            data => {
                this.behDataByTowerForStatus = data;
                this.loading = false;
              
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    // Get Beh comp data
    private getFunDataByTowerIdForReportForStatus() {
        this.loading = true;
        // let postData = { towerId: this.selectedTowerId };
        let postData = { towerId: this.towerIdsBySelectedIbu };
        this.commonService.getFunDataByTowerIdReportForStatus(postData).pipe(first()).subscribe(
            data => {
                this.funDataByTowerForStatus = data;
                this.loading = false;
               
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }



    async getBehDataByTowerIdForReport() {
        let postData = { towerId: this.towerIdsBySelectedIbu };
        return new Promise((resolve, reject) => {
            this.commonService.getBehDataByTowerIdReport(postData).pipe(first()).subscribe(
                data => {
                    data = (data) ? data : [];
                    this.behCompByTowers = data;
                    
                    resolve(data);
                },
                error => {
                    reject(error);
                    localStorage.setItem('errorMsg', error.statusText);
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                    this.loading = false;
                }
            )
        });

    }
    // Get functional competency and competency rating details.
    async getFunDataByTowerIdForReport() {
        let postData = { towerId: this.towerIdsBySelectedIbu };
        return new Promise((resolve, reject) => {
            this.commonService.getFunDataByTowerIdReport(postData).pipe(first()).subscribe(
                data => {
                    this.funCompByTowers = data;
                    resolve(data);
                },
                error => {
                    reject(error);
                    localStorage.setItem('errorMsg', error.statusText);
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                }
            )
        })
    }
    // Get IBU name
    getIbuNameById() {
        for (let i = 0; i < this.ibuList.length; i++) {
            if (this.ibuList[i].ibuId == this.selectedIbuId) {
                this.ibuName = this.ibuList[i].ibuName;
                return this.ibuList[i].ibuName;
            }
        }
    }

    private fetchPositions() {
        this.commonService.getAllPositionInfo(this.selectedTowerId).pipe(first()).subscribe(
            data => {
                this.positionList = data;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }


 
    

}
